import IBModuleApi from "../../api/iuviBankingAPI";
import { urlContexts } from "../../constants";

export const getAppsInfo = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent/info`
  );

  return data;
};

export const getAgents = async () => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent`
  );

  return data;
};

export const getAgent = async (agentId: string) => {
  const { data } = await IBModuleApi.get(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent/${agentId}`
  );

  return data;
};

export const createAgent = async (createInfo: any) => {
  const { data } = await IBModuleApi.post(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent`,
    createInfo
  );

  return data;
};

export const updateAgent = async (updateInfo: any) => {
  const { data } = await IBModuleApi.put(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent`,
    updateInfo
  );

  return data;
};

export const deleteAgent = async (agentId: number) => {
  const { data } = await IBModuleApi.delete(
    `${process.env.REACT_APP_BACKEND_HOST}/${urlContexts.console}/rest/1.0/cs/agent/${agentId}`
  );

  return data;
};
